var exports = {
  "Ew": "MessageAttachments.module__forwardedContainer___RjUxNk",
  "iE": "MessageAttachments.module__forwardedBar___RjUxNk",
  "Q$": "MessageAttachments.module__forwardedContent___RjUxNk",
  "Sd": "MessageAttachments.module__forwardedHeader___RjUxNk",
  "Q_": "MessageAttachments.module__forwardedIcon___RjUxNk",
  "nQ": "MessageAttachments.module__forwardedLabel___RjUxNk",
  "KK": "MessageAttachments.module__attachmentsContainer___RjUxNk",
  "R$": "MessageAttachments.module__urlEmbedSpoiler___RjUxNk",
  "eb": "MessageAttachments.module__forwardedSourceButton___RjUxNk",
  "O_": "MessageAttachments.module__forwardedSourceLabel___RjUxNk",
  "wM": "MessageAttachments.module__forwardedSourceInfo___RjUxNk",
  "Lk": "MessageAttachments.module__forwardedSourceIcon___RjUxNk",
  "ZF": "MessageAttachments.module__forwardedSourceAvatar___RjUxNk",
  "qM": "MessageAttachments.module__forwardedSourceGuildIcon___RjUxNk",
  "T5": "MessageAttachments.module__forwardedSourceChevron___RjUxNk",
  "V0": "MessageAttachments.module__forwardedSourceName___RjUxNk",
  "ye": "MessageAttachments.module__stickersContainer___RjUxNk",
  "Bd": "MessageAttachments.module__stickerWrapper___RjUxNk",
  "Rq": "MessageAttachments.module__stickerWrapperInteractive___RjUxNk",
  "HF": "MessageAttachments.module__stickerImage___RjUxNk",
};

module.exports = exports;
